import React, { useEffect, useState ,useRef , useMemo} from 'react';
import YarnContractDeliveryScheduleService from '../../services/yarn-contract-delivery-schedule.service';
import './yarn-contract-delivery-schedule-list.scss';
import {
  GridComponent,
  Inject,
  Toolbar,
  ToolbarItems,
  Edit,
  EditSettingsModel,
  Page,
  Sort,
  Grid,
  Resize,
  FilterSettingsModel,
  Filter,
  AggregateColumnDirective,
  ColumnDirective,
  ColumnsDirective,
  AggregateColumnsDirective,
  AggregateDirective,
  AggregatesDirective,
  Aggregate,
  ColumnChooser,
  Reorder,
  DialogEditEventArgs,
} from '@syncfusion/ej2-react-grids';
import moment from 'moment'
import securityService from '../security/security.service';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import CommonService from '../../services/common.service';
import { ClickEventArgs } from '@syncfusion/ej2-react-navigations';
import AuditTableInput from '../audit-table/audit-table'
import HardDelete from '../hard-delete/hard-delete';
let selectedRows = []
export default function YarnContractDeliveryScheduleList(props) {
  console.log(props);
  const [yarnContracts, setYarnContracts] = useState([]);
  const [showDialog, setShowDialog] = useState(false);

    const [deleteDialogVisibility, setDeleteDialogVisibility] = useState(false);
  const [dialogWarningVisibility, setDialogWarningVisibility] = useState(false);
  const [warningMessage, setWarningMessage] = useState('');
  const deleteDialog = useRef();
  const warningDialog = useRef();
  const [deletingID, setDeletingID] = useState(0);
  const [showDialogs, setShowDialogs] = useState();
  const [deletingProps, setDeletingProps] = useState();


  let deliveryScheduleGrid: Grid;

  useEffect(() => {
    // const type = getRoute()[1];
    getYarnContractDeliverySchedule();
  }, []);

  const toolbarOptions: ToolbarItems[] = [
    'Add',
    'Edit',
    {
      text: "Delete", tooltipText: "Delete", id: "Delete", disabled: false
    },
    'Update',
    'Cancel',
  ];

  // const databound = () =>
  // {
  //     if (deliveryScheduleGrid) {
  //       deliveryScheduleGrid.autoFitColumns();
  //     }
  // }


  const getYarnContractDeliverySchedule = async () => {
    console.log("Yarn Delivery Schedule", props)
    if(props?.YarnContractID) {
    // props.YarnContractID
      YarnContractDeliveryScheduleService.get(props?.YarnContractID)
      .then((response) => {
        console.log(response);
        setYarnContracts(response.data.recordset);
      })
      .catch((e) => {
        console.log(e);
      });
    }
    
  };

  const getRoute = () =>
    window.location.pathname
      .substr(1, window.location.pathname.length)
      .split('/');

  const actionComplete = (args: DialogEditEventArgs) => {
    if (args.requestType === 'save' && args.action === 'add') { 
      // console.log('data: ', args);
      const schedule = {
        //OrderID: props.OrderID,
        // TODO: Confirm if this is right?
        YarnContractID: props.YarnContractID,
        DeliveryMonth: moment(args.data.DeliveryMonth).format('YYYY-MM-DD'),
        DeliveryQuantity: args.data.DeliveryQuantity,
        CreatedByUserID: userId,
      };
      console.log('schedule : ', schedule);
      YarnContractDeliveryScheduleService.create(schedule)
        .then((response) => {
          console.log(response);
          let AddData = {
            DeliveryQuantity:args.data.DeliveryQuantity,
            DeliveryMonth:moment(args.data.DeliveryMonth).format('YYYY-MM-DD')
          }
          AuditTableInput.auditAdd(
            `YarnContract_DeliverySchedule`,
          `YarnContract_DeliverySchedule`,
          `YarnContractDeliveryScheduleID`,
          AddData)
          getYarnContractDeliverySchedule();
          deliveryScheduleGrid.refresh();
        })
        .catch((e) => {
          console.log(e);
        });
    }
    if (args.requestType === 'save' && args.action === 'edit') { 
      // console.log('data: ', args);
      const schedule = {
        //OrderID: props.OrderID,
        // TODO: Confirm if this is right?
        YarnContractID: props.YarnContractID,
        DeliveryMonth: moment(args.data.DeliveryMonth).format('YYYY-MM-DD'),
        DeliveryQuantity: args.data.DeliveryQuantity,
      UserID: userId,
      };
      console.log('schedule : ', args.data.YarnContractDeliveryScheduleID);
      YarnContractDeliveryScheduleService.update( args.data.YarnContractDeliveryScheduleID ,schedule)
        .then((response) => {
          console.log(response);
          let EditData = {
            DeliveryQuantity:args.data.DeliveryQuantity,
            DeliveryMonth:moment(args.data.DeliveryMonth).format('YYYY-MM-DD')
          }
          let totalColumns = Object.keys(EditData);
          console.log(totalColumns)
          let selectedRowData = {
            ...selectedRows,
            DeliveryMonth:moment(selectedRows.DeliveryMonth).format('YYYY-MM-DD')
          }

          AuditTableInput.auditEdit(totalColumns,selectedRowData,EditData,`YarnContract_DeliverySchedule`,selectedRows.YarnContractDeliveryScheduleID)

          getYarnContractDeliverySchedule();
          deliveryScheduleGrid.refresh();
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  const editSettings: EditSettingsModel = {
    allowEditing: true,
    allowAdding: true,
    allowDeleting: true,
    mode: 'Normal',
    showDeleteConfirmDialog: true,
  };

  const filterOptions: FilterSettingsModel = {
    type: 'Excel',
    columns: [
      {
        field: 'IsDeleted',
        operator: 'equal',
        value: 'False'
      }
    ]
  };

  const sortingOptions: SortSettingsModel = {
    columns: [{ field: 'DeliveryMonth', direction: 'Ascending' }]
  }

  const toolbarClick = (args: ClickEventArgs) => {
    // console.log('args.item.properties :', args);
    if (deliveryScheduleGrid && args.item.properties.id === 'Delete') {
      console.log('toolbar Delete');
      if (deliveryScheduleGrid.selectedRowIndex === -1) {
        // no rows selected
        console.log('Delete ', deliveryScheduleGrid.getSelectedRecords()[0]);
        // setDialogWarningVisibility(false);
        setWarningMessage('Please select a row first!');
        warningDialog.current.show();
      } else {
        console.log('delete: ', deliveryScheduleGrid.getSelectedRecords()[0]?.YarnContractDeliveryScheduleID)
        // deleteDialog.current.hide();
        // setDeletingID(deliveryScheduleGrid.getSelectedRecords()[0]?.YarnContractDeliveryScheduleID);
        // deleteDialog.current.show();
        let obj={
          TableName:`YarnContract_DeliverySchedule`,
          ColumnName:`YarnContractDeliveryScheduleID`,
          RowID:deliveryScheduleGrid.getSelectedRecords()[0]['YarnContractDeliveryScheduleID'],
          SelectedRow:true,
          DeleteSecurity:`YarnContractDeliveryScheduleDelete`,
          UserID:userId,
          SelectedRowData:{
            // DeliveryMonth: ,
            DeliveryQuantity:deliveryScheduleGrid.getSelectedRecords()[0].DeliveryQuantity,
            DeliveryMonth:moment(deliveryScheduleGrid.getSelectedRecords()[0].DeliveryMonth).format('YYYY-MM-DD'),
             
           
     
      }

          
    }
          setDeletingProps(obj)
        
        // deleteDialog.current.show();
        setShowDialogs(true)
      }
    }
  };

  const monthValidationRules = {
    required: true,
    date: true,
  };

  const balanceBags = (yarnContracts) => {
    console.log('yarn');
    // get all rows and calculate the total
    return 2000;
  };

  const quantityValidationRules = {
    required: true,
   // number: true,
    max: balanceBags(),
  };


  const dialogClose = () => {
    this.buttonInstance.style.display = 'inline-block';
    setShowDialog(false);
  };

  const deleteRow = () => {
    CommonService.delete(userId, 'YarnContractDeliveryScheduleDelete', 'YarnContract_DeliverySchedule', 'YarnContractDeliveryScheduleID', deletingID, 1)
      .then(async (response) => {
        // setDialogWarningVisibility(false);
        // console.log("Message is about to set to ", response?.data?.recordset[0]?.Message);
        setWarningMessage(response?.data?.recordset[0]?.Message);
        // console.log("Message is set");
        warningDialog.current.show();
        // if (!(response?.data?.recordset[0]?.Message.includes('access denied'))) {
        //   // record was succesfully deleted
        //   const type = getRoute()[1];
        //   await getYarnContracts(type);
        //   // console.log("record was succesfully deleted");
        // }
        // console.log("Dialog Turned on");
      })
      .catch((e) => {
        // setWarningMessage('Error: ');
        // setDialogWarningVisibility(true);
        console.log('Error: ', e);
      });;
  };

  const deleteButtons = [
    {
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      click: (e) => {
        deleteDialog.current.hide();
        console.log(e);
        deleteRow();
      },
    },
    {
      buttonModel: {
        content: 'Cancel',
        cssClass: 'e-flat',
      },
      click: () => {
        deleteDialog.current.hide();
      },
    },
  ];

  const warningButtons = [
    {
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      click: () => {
        warningDialog.current.hide();
        // setTimeout(() => {
        //   if (!(warningMessage.includes('access denied'))) {
        //     // record was succesfully deleted
        //     const type = getRoute()[1];
        //     getYarnContracts(type);
        //     // console.log("record was succesfully deleted");
        //   }
        // }, 500);

      },
    },
  ];

  function deleteDialogClose() {
    setDeleteDialogVisibility(false);
  }

  function warningDialogClose() {
    setDialogWarningVisibility(false);
    if (!(warningMessage.includes('access denied'))) {
      // record was succesfully deleted
      const type = getRoute()[1];
      getYarnContractDeliverySchedule();
      deliveryScheduleGrid.refresh();
      // console.log("record was succesfully deleted");
    }
  }

      const userId = securityService.getLoggedInUserId();

      const thousandSeperator = (value: string, data: object, column: Column) => {
      
        console.log(value);
        if (value) {
            let parts = value.toString().split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return parts.join('.');
        }
    }

    const Sum = (e: any) => {
      console.log(e.Sum)
        // return <span> {e.Sum.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</span>;
    };
    const footerSum = (e: any) => {
        return <span> Sum: {e.Sum.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</span>;
    };
  return (
    <div className='delivery-schedule-container'>
      {showDialogs ?
          <HardDelete
            {...deletingProps} 
            showResult={(e)=>{
                                console.log(e)

                                setShowDialogs(false)
                                if(e == false){
                                  setShowDialogs(false)
                                  // setProcessingDetails(
                                  //   processingDetails.filter(
                                  //     (item) => item?.FabricProcessingContractDetailID !== deletingID
                                  //   )
                                  // );

                                  //  fabricProcessingContractGrid.dataSource[args?.rowIndex] =   args?.data;
        // console.log("save: ", data);
        // FabricProcessingContractService.create(data);
        setTimeout(() => {
          
          // yarnCountGrid.refresh()
          // getYarnPurchaseTransactions();
          getYarnContractDeliverySchedule()

        }, 200);
      // getProductCutSize(props.path.substring(1));

                                  // const type = getRoute()[1];
                                  // getProcessDesc(type);
                                }
              }} 
                ></HardDelete>
                  :null}
      <div className='row'>
        <div className='col'>
          <label>Order ID:</label>
        </div>
        <div className='col'>
          <label>{props.OrderID}</label>
        </div>
      </div>

      <div className='row'>
        <div className='col'>
          <label>Order Date:</label>
        </div>
        <div className='col'>
          <label>{moment(props?.OrderDate).format('DD/MM/YY')}</label>
        </div>
      </div>

      <div className='row'>
        <div className='col'>
          <label>Company Name:</label>
        </div>
        <div className='col'>
          <label>{props.CompanyName}</label>
        </div>
      </div>

      <div className='row'>
        <div className='col'>
          <label>Yarn Count:</label>
        </div>
        <div className='col'>
          <label>{props.FullYarnCount}</label>
        </div>
      </div>
      <div className='row'>
        <div className='col'>
          <label>Yarn Brand:</label>
        </div>
        <div className='col'>
          <label>{props.BrandName}</label>
        </div>
      </div>
      <div className='row'>
        <div className='col'>
          <label>Bags Ordered:</label>
        </div>
        <div className='col'>
          <label>{
             thousandSeperator( props.OrderBags)
         }</label>

        </div>
      </div>

      <br />
      <div>
              <DialogComponent
                ref={deleteDialog}
                width={500}
                visible={deleteDialogVisibility}
                close={deleteDialogClose}
                content={() => (<div>Are you sure you want to delete?</div>)}
                isModal={true}
                header='Confirmation'
                buttons={deleteButtons}
              // footerTemplate={footerTemplate}
              />
              <DialogComponent
                ref={warningDialog}
                width={400}
                visible={dialogWarningVisibility}
                close={warningDialogClose}
                content={() => (<div>{warningMessage}</div>)}
                isModal={true}
                header='Warning'
                buttons={warningButtons}
              // footerTemplate={footerTemplate}
              />
            </div>
      <GridComponent
        ref={(grid) => (deliveryScheduleGrid = grid)}
        id='yarnContractDeliveryScheduleGrid'
        dataSource={yarnContracts}
        editSettings={editSettings}
        toolbar={toolbarOptions}
        pageSettings={{ pageCount: 4, pageSizes: true, pageSize: 5 }}
        filterSettings={filterOptions}
        actionComplete={actionComplete}
        allowTextWrap='true'
        allowPaging={true}
        allowSorting={true}
        allowPdfExport={true}
        allowExcelExport={true}
        toolbarClick={toolbarClick}
        allowFiltering={true}
        showColumnChooser={true}
        allowReordering={true}
        sortSettings={sortingOptions}
        rowSelected={
          (args)=>{
            console.log(args.data)
            if(selectedRows.length  == 0){
            
            selectedRows = args.data
            }
                      setTimeout(() => {
              console.log('ss')
            }, 200);
          }
        }
        // dataBound={databound}
      >
        <ColumnsDirective>
          <ColumnDirective
            headerText='Order ID'
            field='YarnContractID'
            width='120'
            textAlign='Left'
            visible={false}
          />
          <ColumnDirective
            headerText='Month'
            field='DeliveryMonth'
            width='25'
            type='date'
            format='dd/MM/yy'
            textAlign='Right'
            headerTextAlign='center'
            editType='datepickeredit'
            validationRules={monthValidationRules}
          />
          <ColumnDirective
            headerText='Quantity'
            field='DeliveryQuantity'
            editType='numericedit'
            headerTextAlign='center'

            textAlign='right'
           format={'n0'}
            width='25'
            
            // textAlign='Right'
            // edit= {{ decimals: 0 } }
            validationRules={quantityValidationRules}
          />

          <ColumnDirective
            headerText='YarnContractDelilveryScheduleID'
            field='YarnContractDelilveryScheduleID'
            width='200'
            visible={false}
          />
          <ColumnDirective
                  headerText='Cancel'
                  headerTextAlign='Center'
                  field='IsDeleted'
                  width='140'
                  textAlign='left'
                  visible={false}
                />
        </ColumnsDirective>
        <Inject
          services={[Edit, Toolbar, Page, Sort, Filter, Aggregate, Reorder, Resize]}
        />
            <AggregatesDirective>

<AggregateDirective>
    <AggregateColumnsDirective>

        <AggregateColumnDirective
            field='DeliveryQuantity'
            type='Sum'
        format={'n0'}
        />

    </AggregateColumnsDirective>
</AggregateDirective>
</AggregatesDirective>
      </GridComponent>
    </div>
  );
}
